import { event }  from '~/events'
import pluralize from 'pluralize'
import { ErrorAlert } from '~/Swals'

export default {
    props: {
        overrideEndpoint: {
            type: String,
            required: false,
            default: null,
        },
    },

    data() {
        return {
            hasSingleStoreMethod: false,
            scrolled: true,
            entity: '',
            retrieving: false,
            retrieved: {},
            baseUri: '/api/admin/',
            swal: true,
            resetForm: true,
        }
    },

    mounted: function() {
        event.init();
        event.on('scrollToInput', this.scrollToError);
        this.$store.dispatch('refreshSettings');

        // let input = document.querySelector('[autofocus]');
        let input = this.$el && this.$el.querySelector('[autofocus]');
        if (input) {
            // this.$nextTick(() => {
            //     input.focus()
            // })
            this.$nextTick(() => input.focus({ preventScroll: true }));
        }
    },

//    mounted() {
//         console.time('FormMixin mounted total');

//         console.time('event.init');
//         event.init();
//         console.timeEnd('event.init');

//         console.time('event.on scrollToInput');
//         event.on('scrollToInput', this.scrollToError);
//         console.timeEnd('event.on scrollToInput');

//         // Measure dispatch start->finish (async)
//         console.time('refreshSettings');
//         const p = this.$store.dispatch('refreshSettings');
//         Promise.resolve(p)
//             .then(() => console.timeEnd('refreshSettings'))
//             .catch(() => console.timeEnd('refreshSettings')); // ensure it ends even on error

//         // Measure sync autofocus work + when focus actually happens
//         console.time('autofocus.sync');
//         // const input = document.querySelector('[autofocus]');
//         let input = this.$el && this.$el.querySelector('[autofocus]');
//         console.timeEnd('autofocus.sync');

//         if (input) {
//             console.time('autofocus.nextTick');
//             this.$nextTick(() => {
//                 input.focus();
//                 console.timeEnd('autofocus.nextTick');
//             });
//         }

//         // Autofocus: only inside THIS component, and only if it’s visible/focusable
//         // const focusAutofocus = () => {
//         //     // scope to this component (prevents picking an autofocus elsewhere in the huge table)
//         //     const root = this.$el;
//         //     if (!root) return;

//         //     const el = root.querySelector('[autofocus]');
//         //     if (!el) return;

//         //     // avoid focusing hidden/disabled elements (prevents weird focus trap loops)
//         //     const isDisabled = el.disabled || el.getAttribute('aria-disabled') === 'true';
//         //     const isHidden = el.offsetParent === null; // quick "not visible" check
//         //     if (isDisabled || isHidden) return;

//         //     // focus without scrolling the whole page
//         //     try {
//         //         el.focus({ preventScroll: true });
//         //     } catch (e) {
//         //         el.focus(); // fallback for older browsers
//         //     }
//         // };

//         // // For modals, DOM/layout is often not stable on nextTick.
//         // // Use RAF (or two RAFs) so BootstrapVue has finished showing + focusing.
//         // requestAnimationFrame(() => {
//         //     requestAnimationFrame(() => {
//         //         focusAutofocus();
//         //     });
//         // });

//         console.timeEnd('FormMixin mounted total');
//     },

    created: function() {
        if (this.isUpdate()) {
            this.retrieve();
        }
    },

    computed: {
        ready() {
            let ready = !_.isEmpty(this.retrieved) || (!this.isUpdate());

            if (ready) {
                setTimeout(() => { this.$emit('formReady') }, 100);
            }

            return ready
        }
    },

    methods: {
        field(name) {
            if (!this.isUpdate()) {
                return null;
            }

            let value = _.get(this.retrieved, name, undefined);

            if (typeof value === 'undefined') {
                console.warn(name + ' not in retrieved data', _.clone(this.retrieved));
                return null;
            }

            return value
        },

        scrollToError() {
            if(this.scrolled){
                return null;
            }

            this.scrolled = true;

            let scroll = this.$scrollTo;


            let elements = document.getElementsByClassName("form-control-feedback");
            setTimeout(() => {scroll(elements[0], 400, { offset: -150 })}, 175);
        },

        /**
         * Runs before persisting or updating an resource.
         *
         * If this method returns false, the request will not be done
         *
         * @return boolean | null
         */
        beforeStore() {
            return true;
        },

        /**
         * Persists or updates the resource
         * @return {[type]}
         */
        async store() {
            if (this.beforeStore() === false) {
                return;
            }
            this.scrolled = false;
            this.$emit('onStore');

            let data;
            let error = null;

            let url = this.fullBaseUri()

            if (this.isUpdate() && !this.hasSingleStoreMethod) {
                url += `/${this.id}`
            }

            await this.form[this.method()](url).then((response) => {
                data = response;
            }).catch((e) => {
                error = e;
            });

            if(error !== null) {
                this.$emit('onError', error);

                if (!error.errors) {
                    new ErrorAlert({'text': error.message}).show()
                }

                return;
            }

            if (this.isUpdate()) {
                this.$emit('afterUpdate', data);
            } else {
                this.$emit('afterStore', data);
            }

            if (this.shouldResetForm()) {
                this.form.reset();
            }

            if (this.swal) {
                swal(this.swalTitle(data), this.uLang(this.isUpdate() ? 'app.entity_edited' : 'app.entity_created', { entity: this.lang('app.' + this.entity.replace(/-/g, "_"))}), 'success');
            }
        },

        swalTitle(data) {
            return data.name || this.uLang('app.' + this.entity.replace(/-/g, "_"))
        },

        /**
         * Retrieves the resource
         * @return {[type]}
         */
        async retrieve() {
            this.$emit('beforeRetrieve');
            this.retrieving = true;
            await window.axios.get(this.fullBaseUri() + '/' + this.id).then(({data}) => {
                this.form.fill(data);
                this.retrieved = data;
                this.retrieving = false;
                this.$emit('afterRetrieve', data);
            })
        },

        /**
         * Retrieves the full base url for every request
         * @return String
         */
        fullBaseUri() {
            if (this.overrideEndpoint !== null) {
                return this.overrideEndpoint
            }

            return this.baseUri + pluralize(this.entity)
        },

        /**
         * Determins wether this is an update or store
         * @return Boolean
         */
        isUpdate() {
            if(this.isFormForUpdate === true) {
                return true
            }

            return typeof this.id !== 'undefined' && this.id !== null;
        },

        onError(error) {
            console.log(JSON.parse(JSON.stringify(error)));
        },

        /**
         * Returns which method should be used
         * @return String
         */
        method() {
            return this.isUpdate() && !this.hasSingleStoreMethod ? 'put' : 'post';
        },

        /**
         * Returns if we should reset the form after saving
         * @return Boolean
         */
        shouldResetForm() {
            return !this.isUpdate() && this.resetForm;
        },
    }
}
